/* eslint-disable */
<template>
  <div class="page-content">
    <div class="bid-details">
      <h5 class="mb-3">İstenen Teklif Detayı</h5>
      <div class="vue-wait-class" v-if="$wait.waiting('teklif-loading')">
        <img src="static/loading.svg" />
        <p>Teklif yükleniyor...</p>
      </div>
      <div v-else class="row g-5">
        <div class="col-12 mb-3">
          <label>Teklif İsteyen Kişi</label>
          <input type="text" readonly class="form-control" :value="teklif.Name">
        </div>
        <div class="col-12 mb-3">
          <label>Teklif İsteyen Firma</label>
          <input type="text" readonly class="form-control" :value="teklif.Company">
        </div>
        <div class="col-6 mb-3">
          <label>Mail Adresi</label>
          <input type="text" readonly class="form-control" :value="teklif.EMail">
        </div>
        <div class="col-6 mb-3">
          <label>İletişim Numarası</label>
          <input type="text" readonly class="form-control" :value="teklif.GsmNo">
        </div>
        <div class="col-6 mb-3">
          <label>Hangi Ürünü İstiyor?</label>
          <input type="text" readonly class="form-control" :value="parseOfferProduct(teklif.Product)">
        </div>
        <div class="col-6 mb-3">
          <label>Kaç Adet İstiyor?</label>
          <input type="text" readonly class="form-control" :value="teklif.Quantity">
        </div>
        <div class="col-6 mb-3">
          <label>Hat İstiyor mu?</label>
          <input type="text" readonly class="form-control" :value="teklif.SIMNeeded == true ? 'Evet' : 'Hayır'">
        </div>
        <div class="col-6 mb-3">
          <label>Blokaj İstiyor mu?</label>
          <input type="text" readonly class="form-control" :value="teklif.MBNeeded == true ? 'Evet' : 'Hayır'">
        </div>
        <div class="col-12 mb-3">
          <label>Müşteri Mesajı</label>
          <textarea readonly class="form-control" :value="teklif.Message" />
        </div>
        <div class="col-12">
          <label>Teklif Talebinin Durumu</label>
        </div>
        <div class="col-6 mb-5">
          <select class="form-control" v-model="teklif.Status">
            <option value=0>Teklif Bekliyor</option>
            <option value=1>Yanıt Bekliyor</option>
            <option value=2>Zaman Aşımına Uğradı</option>
            <option value=3>Satışa Dönüştü</option>
            <option value=4>Reddedildi</option>
          </select>
        </div>
        <div class="col-6 mb-3">
          <button type="button" class="btn btn-success" @click="updateSingleTeklif()">Teklif Durumunu Güncelle</button>
        </div>
      </div>
    </div>
    <div id="conversation-body-messages" class="chat">
      <div class="messages" id="chat-messages">
        <div class="vue-wait-class" v-if="$wait.waiting('mesajlar-loading')">
          <img src="static/loading.svg" />
          <p>Mesajlar yükleniyor...</p>
        </div>
        <div v-else class="row mb-4" :id="'message-row' + index" v-for="(message, index) in messages" :key="message.MESSAGE_ID">
          <div class="col-md-12">
            <div class="bubble clearfix" v-bind:class="{'own text-right' : message.PERSONEL_ID == getPersonelId}">
              <span class="my-0" v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId}">{{message.MESSAGE_TEXT}}</span>
              <small class="text-muted mt-1"
                v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId, 'float-left': message.PERSONEL_ID != getPersonelId}" >
                {{message.MESSAGE_DATE}} - {{message.PERSONEL_NAME}}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="text-panel">
        <div class="input-group">
          <textarea class="form-control" :disabled="!canWriteMessage" placeholder="Notunuzu buraya yazın..." v-model="messageText"
            aria-label="Notunuzu buraya yazın..." aria-describedby="button-addon2"></textarea>
          <div class="input-group-append">
            <button class="btn btn-primary" :disabled="!canWriteMessage" @click="insertMesaj()" type="button" id="button-addon2">Mesaj Gönder</button>
          </div>
        </div>
      </div>
    </div>
    <div class="bid-attachments">
      <h5 class="mb-3">Teklif Dosyaları</h5>
      <div class="vue-wait-class" v-if="$wait.waiting('files-loading')">
        <img src="static/loading.svg" />
        <p>Dosyalar yükleniyor...</p>
      </div>
      <div v-else class="bid-documents">
        <div class="bid-document" :id="'file-row' + index" v-for="(file, index) in files" :key="file.FileId">
          <img src="static/pdf-icon.png" height="40" />
          <div class="texts">
            <p class="document-title text">{{cropData(file.FileName, 25)}}</p>
            <div class="document-info">
              <small class="text-small">{{file.PersonelName}}</small>
              <small class="text-small">{{file.CreatedDate}}</small>
            </div>
          </div>
          <a :href="file.FileUrl" class="bid-download" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </a>
        </div>
      </div>
      <div class="bid-upload">
        <h6 class="mt-4">Teklif Dosyası Yükle</h6>
        <ik-upload
          v-if="uploadMode"
          class="form-control"
          :tags="['teklif','pdf', getPersonelName]"
          :responseFields="['tags']"
          :onError=onUploadError
          :onSuccess=onUploadSuccess
          :useUniqueFileName=true
          :folder="'/bids/' + teklif.ID + '/'"
          customCoordinates="10,10,100,100"
        />
        <button v-else @click="uploadMode = true" class="btn btn-outline-primary btn-sm">Yeni Teklif Dosyası Yükle</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import ImageKit, {IKContext, IKUpload} from 'imagekitio-vue';

export default {
  name: 'TeklifDetay',
  components: {
    IKContext,
    IKUpload
  },
  data () {
    return {
      uploadMode: false,
      teklif: null,
      files: [],
      messages: [],
      messageText: '',
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      }
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getPersonelName : function() { return this.$store.getters.getPersonelName },
    canWriteMessage : function() { return this.$store.getters.userCanWriteMessage },
    canReadMessage : function() { return this.$store.getters.userCanReadMessage },
  },
  methods: {
    getSingleTeklif() {
      this.$wait.start('teklif-loading');
      axios
      .get('/api/bids/' + this.$route.params.teklifId)
      .then(response => {
        this.teklif = response.data[0]
        this.$wait.end('teklif-loading')

        this.listBidFiles()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('teklif-loading')
      })
    },
    updateSingleTeklif() {
      this.$wait.start('teklif-loading');
      this.teklif.Status = parseInt(+ this.teklif.Status);

      axios
      .put('/api/bids/' + + this.$route.params.teklifId, this.teklif)
      .then(response => {
        this.$wait.end('teklif-loading')
        this.getSingleTeklif()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('teklif-loading')
      })
    },
    getMesajlar() {
      this.$wait.start('mesajlar-loading');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.TalepId = parseInt(this.$route.params.teklifId)
      getJson.TalepType = true;

      axios
      .post('/api/bids/' + this.$route.params.teklifId + '/mesajlar', getJson)
      .then(response => {
        this.messages = response.data
        this.$wait.end('mesajlar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesajlar-loading')
      })
    },
    insertMesaj() {
      if(!this.messageText)
        return

      this.$wait.start('mesaj-insert');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.TalepId = parseInt(this.$route.params.teklifId)
      getJson.TalepType = true;
      getJson.MessageText = this.messageText

      axios
      .post('/api/bids/' + this.$route.params.teklifId + '/mesaj-ekle', getJson)
      .then(response => {
        this.$wait.end('mesaj-insert')
        this.messageText = ''
        this.getMesajlar()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesaj-insert')
      })
    },
    parseOfferProduct(product) {
      if (product == 1)
        return "Lenoi Max";
      else if (product == 2)
        return "Lenoi PRO";
      else if (product == 3)
        return "HX10 NVR";
      else if (product == 4)
        return "HX11 NVR";
      else if (product == 5)
        return "HX12 NVR";
      else if (product == 6)
        return "LNX66 IP Kamera";
      else return "Tanımsız";
    },
    parseOfferStatus(status) {
      if (status == 0)
        return "Teklif Bekliyor";
      else if (status == 1)
        return "Yanıt Bekleniyor";
      else if (status == 2)
        return "Zaman Aşımı";
      else if (status == 3)
        return "Satışa Dönüştü";
      else if (status == 4)
        return "Reddedildi";
      else return "Tanımsız";
    },
    parseOfferStatusClass(status) {
      if (status == 0)
        return "badge-primary";
      else if (status == 1)
        return "badge-warning";
      else if (status == 2)
        return "badge-secondary";
      else if (status == 3)
        return "badge-success";
      else if (status == 4)
        return "badge-danger";
      else return "Tanımsız";
    },
    onUploadError(err) {
      console.log(err);
      this.$toasted.success('Teklif dosyası yüklenemedi!', this.toastOptions)      
    },
    onUploadSuccess(res) {
      console.log(res)
      this.$toasted.success('Teklif dosyası yüklendi!', this.toastOptions)      
      this.listBidFiles()
    },
    listBidFiles() {
      this.$wait.start('files-loading');

      axios.get('/api/bids/' + this.$route.params.teklifId + '/files')
      .then(res => {
        this.files = res.data
        this.$wait.end('files-loading');
      })
      .catch(err => {
        console.log(err);
        this.$wait.end('files-loading');
      });
    },
    cropData(val, len) { 
      if(val == null || val == undefined)
        return null;

      if((val.length + 3) > len) return val.substring(0, len) + '...' 
      else return val
    },
  },
  mounted() {
    this.getSingleTeklif()
    this.getMesajlar()
  }
}
</script>

<style scoped>
  .page-content {
    width: 100%;
    height: calc(100vh - 80px);
    max-height: calc(100vh - 80px);
    overflow: hidden;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .page-content > .row {
    height: 100% !important;
    max-height: 100% !important;
  }

  .bid-details, .chat, .bid-attachments {
    padding: 1rem;
    border-right: 1px solid #F0F0F0;
    height: 100%;
    max-height: 100%;
  }

  .bid-details {
    flex: 4;
  }

  .bid-attachments {
    padding: 1rem 1.5rem;
    flex: 2;

    display: flex;
    flex-direction: column;
  }

  .bid-documents {
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
    padding-top: .5rem;
  }

  .bid-document {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.5rem 0;
    border-bottom: 1px solid #F0F0F0;
  }

  .bid-document:first-child {
    padding-top: 0;
  }

  .bid-document:last-child {
    border: none;
  }

  .bid-document img {
    width: auto;
    height: 40px;
    margin-right: .75rem;
  }

  .bid-document .texts {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: .75rem;
  }

  .bid-document .texts .document-title {
    margin: 0;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1;
    margin-bottom: 6px;
  }

  .bid-document .texts .document-info {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bid-document .texts .document-info small {
    margin-right: 8px;
    color: #AAA;
    font-size: 12px;
  }

  .bid-document .bid-download {
    display: flex;
    flex-direction: row;
    align-items: center;

    width: auto;
    height: 32px;
    text-align: center;
    text-decoration: none;

    padding: 0 8px;
    border-radius: 6px;
    background-color: #007CF0;
    color: #FFF;
    font-size: 1rem;
    line-height: .9;
    font-weight: 500;
  }

  .bid-document .bid-download svg {
    width: 20px;
    height: 20px;
    text-align: center;
    stroke: #FFF;
  }

  .chat {
    height: 100%;
    max-height: 100%;

    flex: 5;
    display: flex;
    flex-direction: column;
  }

  .chat .messages {
    flex-grow: 1;
    margin-bottom: 10px;
    padding-right: 5px;
    width: 100%;
    height: auto;
    max-height: calc(100% - 62px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .chat .text-panel {

  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
    margin-right: 1rem;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
    margin-right: 1rem;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
    margin-right: 1rem;
  }

</style>


// WEBPACK FOOTER //
// src/components/TeklifDetayPage.vue